<form fxLayout="column" name="accomodation-{{ accomodationId }}">
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Città</mat-label>
      <input name="city" matInput [(ngModel)]="accomodation.city" type="text" required />
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>

    <mat-form-field appearance="outline">
      <mat-label>Data check-in</mat-label>
      <input name="start" matInput readonly [matDatepicker]="pickerStart" [(ngModel)]="accomodation.start"
        (click)="pickerStart.open()" required />
      <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>

    <span>&nbsp;&nbsp;</span>

    <mat-form-field appearance="outline">
      <mat-label>Data check-out</mat-label>
      <input name="end" matInput readonly [matDatepicker]="pickerEnd" [(ngModel)]="accomodation.end"
        (click)="pickerEnd.open()" required />
      <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>

    <span>&nbsp;&nbsp;</span>

    <span *ngIf="
        {
          start: accomodation.start?.toDate(),
          end: accomodation.end?.toDate()
        } | daysBetween;
        let nDays
      ">
      {{ nDays - 1 }}
      notti</span>
  </div>

  <mat-accordion style="padding: 16px 0">
    <mat-expansion-panel *ngFor="let proposal of accomodation.proposals; index as proposalId">
      <mat-expansion-panel-header>
        <mat-panel-title fxLayoutAlign="start center">
          <mat-icon class="header-icon">label_important</mat-icon>
          <span class="header-title" fxFlex>Proposta {{ proposalId + 1 }}
            <span *ngIf="proposal.name">: {{ proposal.name }}</span></span>
          <div class="header-actions always-visible">
            <button mat-icon-button matTooltip="Imposta questa sistemazione come preferita"
              (click)="setFavoriteProposal($event, proposal)" [disabled]="disabled">
              <mat-icon aria-label="Preferito?">{{
                proposal.favorite ? "favorite" : "favorite_border"
                }}</mat-icon>
            </button>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxLayout="row" fxLayoutAlign="center center">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Nome struttura</mat-label>
          <input name="proposal-{{ proposalId }}-name" matInput [(ngModel)]="proposal.name" type="text" required />
        </mat-form-field>
        <span>&nbsp;&nbsp;</span>
        <mat-form-field appearance="outline">
          <mat-label>Tipo</mat-label>
          <mat-select [(ngModel)]="proposal.type" name="proposal-{{ proposalId }}-type" [disabled]="disabled" required>
            <mat-option *ngFor="let type of accomodationTypesData" [value]="type.key">
              {{ type.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <span>&nbsp;&nbsp;</span>

        <button mat-icon-button (click)="proposal.stars = null" *ngIf="!disabled">
          <mat-icon>cancel</mat-icon>
        </button>
        <app-star-rating [(value)]="proposal.stars" [disabled]="disabled"></app-star-rating>

        <span>&nbsp;&nbsp;</span>

        <mat-form-field appearance="outline" style="width: 300px">
          <mat-label>Posizione su Mappa</mat-label>
          <mat-icon matSuffix>place</mat-icon>
          <app-lat-lng-input [disabled]="disabled" [(value)]="proposal.place" [searchText]="proposal.name"
            required></app-lat-lng-input>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center start">
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Descrizione</mat-label>
          <textarea style="height: 199px" name="proposal-{{ proposalId }}-description" matInput
            [(ngModel)]="proposal.description" required></textarea>
          <app-inline-help-button matSuffix [title]="'Descrizione'" [content]="
              'Inserisci una breve descrizione delle caratteristiche dell\'alloggio. Ad esempio, per auto inserisci informazioni come bagno in camera, distanza dal centro, parcheggio, ecc ecc.\n\nAttenzione a non eccedere lo spazio disponibile nell’itinerario, utilizza la funzione “Anteprima” per controllare.'
            ">
          </app-inline-help-button>
        </mat-form-field>
        <span>&nbsp;&nbsp;</span>
        <app-itinerary-image-form-field [disabled]="disabled" [(image)]="proposal.image"
          [label]="'Foto *'"></app-itinerary-image-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="center start">
        <mat-form-field appearance="outline" style="width: 250px">
          <mat-label>Prezzo totale per {{ npax }} persone</mat-label>
          <input name="proposal-{{ proposalId }}-price" matInput [(ngModel)]="proposal.price" type="number" required />
          <mat-icon matSuffix>euro_symbol</mat-icon>
        </mat-form-field>
        <span>&nbsp;&nbsp;</span>
        <mat-form-field appearance="outline">
          <mat-label>Partner</mat-label>
          <mat-select [(ngModel)]="proposal.partner" name="partner" [disabled]="disabled">
            <mat-option *ngFor="let affiliationPartner of affiliationPartnerData" [value]="affiliationPartner.key">
              {{ affiliationPartner.label }}
            </mat-option>
            <mat-option [value]="null">Altro</mat-option>
          </mat-select>
        </mat-form-field>
        <span>&nbsp;&nbsp;</span>
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Link prenotazione</mat-label>
          <input name="proposal-{{ proposalId }}-link" matInput [(ngModel)]="proposal.link.longUrl" type="url"
            required />
          <app-inline-help-button matSuffix [title]="'Link prenotazione'" [content]="
              'Inserisci qui il link alla pagina di prenotazione. Controlla che il link sia funzionante copiandolo e incollandolo in una finestra di navigazione in incognito.'
            ">
          </app-inline-help-button>
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</form>